/**
 * Normalize an email address for case-insensitive comparison and storage.
 * Trims surrounding whitespace and lowercases it, since email addresses are
 * not case-sensitive in practice.
 */
export const normalizeEmail = (email: string): string => email.trim().toLowerCase();
